import { createFileRoute } from "@tanstack/react-router";
import AdminPendingTeammateInvites from "@/pages/AdminPendingTeammateInvites";

export const Route = createFileRoute("/admin/pending-teammate-invites/")({
  component: AdminPendingTeammateInvites,
});
